module.exports = __webpack_public_path__ + "static/media/support-active.9bb8bde4.svg";